import { type ApolloLink, split } from '@apollo/client';

import { getSubscriptionTransport } from '@/lib/ws/subscription-transport';

/**
 * 購読の転送方式（WebSocket か SSE）を、送信のたびに決めて振り分けるリンク。
 * 方式は組織の設定とブラウザごとの上書きで決まり、組織 ID が分かるのは起動後なので、作成時には固定しない。
 */
export function createSubscriptionLink(sseLink: ApolloLink, wsLink: ApolloLink): ApolloLink {
  return split(() => getSubscriptionTransport() === 'sse', sseLink, wsLink);
}
